<template>
    <div>
      <p>Below are competencies you chose to save later.  Please save them now so you can send them to your preceptor.</p>
        <b-table show-empty empty-text="You have no preformed competencies to save at this time." striped responsive stacked="md" :items="items" :fields="fields">
            <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                     <div v-if="row.item.pivot.attempts > 1">
                        <b-button @click="sendPreceptor(row.item.id)" class="btn btn-danger">
                        <span class="icon icon-paper-plane">
                            Save Now</span>
                    </b-button>
                    </div>
                    <div v-else>
                      <b-button @click="sendPreceptor(row.item.id)" class="btn btn-success">
                        <span class="icon icon-save">
                            Save</span>
                    </b-button>
                    </div> 
                </b-button-group>
            </template>
        </b-table>
        <a class="btn btn-danger float-right" href="/competency/clear-all">
            <span class="icon icon-trash">
                Clear All</span>
        </a>
    </div>
</template>

<script>
const items = [];

export default {
  data() {
    return {
      items: items,
      fields: [
        { key: "title", label: "Competency" },
        { key: "standard", label: "Standard" },
        { key: "pivot.attempts", label: "Performed" },
        { key: "actions", label: "Action" }
      ]
    };
  },
  methods: {
    addAttempt(id) {
      axios
        .get("/attempts/add/" + id)
        .then(response => (this.items = response.data))
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },
    removeAttempt(id) {
      axios
        .get("/attempts/remove/" + id)
        .then(response => (this.items = response.data))
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },
    sendPreceptor(id) {
      window.location.href = "/competency/send/" + id;
    }
  },
  mounted() {
    axios
      .get("/attempts")
      .then(response => (this.items = response.data))
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  }
};
</script>

<!-- table-basic-1.vue -->